<div class="modal-retentativa-pagamento">
  <div class="barra-modal"></div>

  <h3>Escolha a forma de pagamento</h3>
  <p>Selecione como deseja pagar seu pedido.</p>

  <div class="opcoes-retentativa">
    <form #frmCarteirasDigitais="ngForm" *ngIf="exibirCarteirasDigitais && pedidoCarteirasDigitais">
      <app-tunnapay-digitais
        [formaDePagamento]="formaPagamentoCarteirasDigitais"
        [pedido]="pedidoCarteirasDigitais"
        [layoutLinkPedido]="true"
        (definiuCartao)="pagueComCarteiraDigital($event)">
      </app-tunnapay-digitais>
    </form>

    <button class="opcao-retentativa" type="button" *ngIf="exibirCartao"
            [disabled]="processando"
            (click)="pagueComCartao()">
      <i class="fe-credit-card icone-cartao"></i>
      <span>
        <strong>Pagar com cartão</strong>
        <small>Crédito ou débito</small>
      </span>
      <i class="fe-chevron-right seta"></i>
    </button>

    <button class="opcao-retentativa" type="button" *ngIf="exibirPix"
            [disabled]="processando"
            (click)="pagueComPix()">
      <i class="fe-grid icone-pix"></i>
      <span>
        <strong>Pix</strong>
        <small>Aprovação imediata</small>
      </span>
      <i class="fe-chevron-right seta"></i>
    </button>
  </div>

  <div class="processando-retentativa" *ngIf="processando">
    <i class="k-icon k-i-loading"></i>
    Processando pagamento...
  </div>

  <button class="btn-cancelar-retentativa" type="button"
          [disabled]="processando"
          (click)="cancele()">
    Cancelar
  </button>
</div>
